// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';
import { type BrazilianDocumentType } from '@tectonics/prs/customer/brazil';

export function validateBrazilianDocument(document: string, documentType: BrazilianDocumentType): ?UserInputValidationError {
  if (documentType === 'cpf')
    return validateCpf(document);
  else
    return validateCnpj(document);
}

function validateCpf(document: string): ?UserInputValidationError {
  if (!document) {
    return { id: 'empty'};
  } else if (!/^\d{11}$/.test(document)) {
    return { id: 'invalid-cpf-pattern' };
  } else if (!validateCpfNumber(document)) {
    return { id: 'invalid-cpf-number' };
  }
}

function validateCnpj(document: string): ?UserInputValidationError {
  if (!/^\d{14}$/.test(document)) {
    return { id: 'invalid-cnpj-pattern' };
  } else if (!validateCnpjNumber(document)) {
    return { id: 'invalid-cnpj-number' };
  }
}

// eslint-disable
export function validateCnpjNumber(number: string): boolean {
  if (typeof number !== 'string')
    return false;

  // $FlowFixMe
  number = number.replace(/[^\d]/g, '');

  const r = /^(0{14}|1{14}|2{14}|3{14}|4{14}|5{14}|6{14}|7{14}|8{14}|9{14})$/;
  if (r.test(number)) return false;

  let remainder = 0;
  let size = number.length - 2;
  let numbers = number.substring(0, size);
  let pos = size - 7;
  const sum = 0;
  const digits = number.substring(size);

  // $FlowFixMe
  const loop = (one, two, three, four) => {
    for (let i = one; i >= 1; i--) {
      // $FlowFixMe
      two += three.charAt(one - i) * four--;
      if (four < 2) four = 9;
    }

    return (two % 11 < 2 ? 0 : 11 - (two % 11)).toString();
  };

  remainder = loop(size, sum, numbers, pos);
  if (remainder !== digits.charAt(0)) return false;

  size += 1;
  numbers = number.substring(0, size);
  pos = size - 7;

  remainder = loop(size, sum, numbers, pos);
  if (remainder !== digits.charAt(1)) return false;

  return true;
}

// eslint-disable
export function validateCpfNumber(number: string): boolean {
  if (typeof number !== 'string')
    return false;

  // $FlowFixMe
  number = number.replace(/[^\d]/g, '');

  const r = /^(0{11}|1{11}|2{11}|3{11}|4{11}|5{11}|6{11}|7{11}|8{11}|9{11})$/;
  let sum = 0;
  let remainder;

  if (r.test(number)) return false;

  // $FlowFixMe
  for (let i = 1; i <= 9; i++) sum += (number.charAt(i - 1, i) * (11 - i));

  remainder = (sum * 10) % 11;

  if ((remainder === 10) || (remainder === 11)) remainder = 0;
  if (remainder.toString() !== number.charAt(9)) return false;

  sum = 0;
  // $FlowFixMe
  for (let i = 1; i <= 10; i++) sum += number.charAt(i - 1, i) * (12 - i);

  remainder = (sum * 10) % 11;

  if ((remainder === 10) || (remainder === 11)) remainder = 0;
  if (remainder.toString() !== number.charAt(10)) return false;

  return true;
}
